import template from './illionBankStatementsButton.template.html';

export default {
  template,
  bindings: {
    ticket: '<',
    contacts: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controllerAs: '$ctrl',
  controller: class controller {
    constructor(illionService, uiService) {
      'ngInject';

      const ctrl = this;
      ctrl.isAnyClientInvited = false;

      ctrl.initialize = () => {
        ctrl.checkIsInvited();
      };

      ctrl.checkIsInvited = () => {
        illionService
          .bankStatementsIsInvited({ idTicket: ctrl.ticket.id, type: 'bankStatements' })
          .then((result) => {
            ctrl.isAnyClientInvited = result.status;
          });
      };

      ctrl.sendBankStatements = ($event, contact) => {
        if (!contact.getEmail() || contact.isCompany) {
          uiService.toast({
            text: {
              p1: 'Contact',
              p2: `${contact.getName()}`,
              p3: contact.isCompany ? 'must be person' : 'does not have email'
            },
            warn: true
          });

          return;
        }

        uiService.toast({
          text: {
            p1: 'Sending request',
            p2: `to ${contact.getName()}`,
            p3: 'please wait...'
          }
        });

        illionService
          .bankStatementsEmailInvite({
            idTicket: ctrl.ticket.id,
            idContact: contact.id
          })
          .then((res) => {
            if (res.status !== true) {
              uiService.toast({
                text: {
                  p1: 'Sending request',
                  p2: `to ${contact.getName()}`,
                  p3: 'failed'
                },
                warn: true
              });

              return;
            }

            uiService.toast({
              text: {
                p1: 'Sending request',
                p2: `to ${contact.getName()}`,
                p3: 'successful'
              },
              success: true
            });

            ctrl.initialize();
            ctrl.onFinished();
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
